import React from 'react';

const ManageAllDrones = () => {
    return (
        <div>
            <h2>Manage All Products</h2>
        </div>
    );
};

export default ManageAllDrones;